// Colony color scale normalization.
//
// The cpu-service phenotypic endpoint (phenotypic_service._measure_colony)
// computes a colony's mean color with OpenCV: cv2.cvtColor(roi, COLOR_BGR2LAB)
// and returns the raw channel means as `mean_color_lab`. For 8-bit images
// OpenCV packs Lab into [0,255]:
//     L_cv = L * 255/100      (L in [0,100])
//     a_cv = a + 128          (a in [-128,127])
//     b_cv = b + 128          (b in [-128,127])
// Every frontend consumer treats mean_color_lab as *standard* CIELAB
// (L 0-100, a/b -128..127) and feeds it into a Lab->RGB converter. Passing the
// packed 0-255 values in unscaled sends them wildly out of gamut and the RGB
// clamps to garbage -- a mid-tone colony lands on pure red, i.e. H0 S100 V100.
//
// Rescale the packed OpenCV values back to standard CIELAB before use.

// OpenCV 8-bit Lab -> standard CIELAB [L, a, b], or null if the input is not a
// usable 3-number array.
export function normalizeColonyLab(lab) {
  if (!Array.isArray(lab) || lab.length !== 3) return null;
  const [L, a, b] = lab;
  if ([L, a, b].some((n) => typeof n !== 'number' || Number.isNaN(n))) return null;
  return [(L * 100) / 255, a - 128, b - 128];
}

// Just the L* channel (standard 0-100) for brightness readouts, or null.
export function normalizeColonyL(L) {
  return typeof L === 'number' && !Number.isNaN(L) ? (L * 100) / 255 : null;
}
